import React, { useContext } from 'react';
import List from '@mui/material/List';
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListIcon from '@mui/icons-material/List';
import ListSubheader from '@mui/material/ListSubheader';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CodeIcon from '@mui/icons-material/Code';
import EditIcon from '@mui/icons-material/Edit';
import useRouter from '../../components/_hook/useRouter';
import useRoutes from '../../components/_hook/useRoutes';
import DrawerListItem from '../../components/_header/DrawerListItem';
import Context from '../../context';

export default function MinisiteDrawer() {
  const { path } = useRoutes();
  const { params } = useRouter();
  const { docID } = params;
  const { company } = useContext(Context);
  const { t } = useTranslation();

  return (
    <>
      <List>
        <DrawerListItem
          path={path('minisite.dashboard', {
            companyID: company._id,
          })}
          primaryText={t('dashboard')}
          icon={<DashboardIcon />}
        />
        <DrawerListItem
          path={path('minisite.list', {
            companyID: company._id,
          })}
          primaryText={t('list')}
          icon={<ListIcon />}
        />
        {docID && (
          <>
            <ListSubheader>{t('minisite')}</ListSubheader>
            <DrawerListItem
              disabled={!docID}
              path={path('minisite.detail', {
                companyID: company._id,
                docID,
              })}
              primaryText={t('detail')}
              icon={<DescriptionIcon />}
            />
            <DrawerListItem
              disabled={docID === 'new'}
              path={path('minisite.page', {
                companyID: company._id,
                docID,
              })}
              primaryText={t('page')}
              icon={<InsertDriveFileIcon />}
            />
            <DrawerListItem
              disabled={docID === 'new'}
              path={path('minisite.theme', {
                companyID: company._id,
                docID,
              })}
              primaryText={t('theme')}
              icon={<EditIcon />}
            />
            <ListSubheader>{t('developer')}</ListSubheader>
            <DrawerListItem
              disabled={docID === 'new'}
              path={path('minisite.developer.meta', {
                companyID: company._id,
                docID,
              })}
              primaryText={t('meta_tag')}
              icon={<CodeIcon />}
            />
            <DrawerListItem
              disabled={docID === 'new'}
              path={path('minisite.developer.analytic', {
                companyID: company._id,
                docID,
              })}
              primaryText={t('analytic_tool')}
              icon={<CodeIcon />}
            />
            <DrawerListItem
              disabled={docID === 'new'}
              path={path('minisite.developer.overwrite', {
                companyID: company._id,
                docID,
              })}
              primaryText={t('overwrite')}
              icon={<CodeIcon />}
            />
          </>
        )}
      </List>
    </>
  );
}
